import React from 'react'
import { graphql, StaticQuery, Link } from 'gatsby';

const Components = () => (
  <React.Fragment>
  <div className="page-welcome-header">
      <h1>Components</h1>
    </div>
    <div className="page-content">
      <blockquote>
        Components, defined by using <i>React</i>, are the more complex UI blocks composed by <Link to="/elements">Elements</Link> and native react dom elements (i.e. a, div, p, etc...).
      </blockquote>
      <p>Differently from the elements package, here every component is available via its own package (you can find the correct package and the version at the end of each component page, i.e. <Link className="link link--colored" to="/components/collapsible#package-version">look at here</Link>)</p>
      <br />
      <p>This is the list of all the components:</p>
      <StaticQuery
        query={graphql`
          query NavComponentsQuery {
            navJson {
              nav {
                name
                path
                navChildren {
                  name
                  path
                }
              }
            }
          }
        `}
        render={({ navJson: { nav } }) => {
          const allElements = nav.filter(({ name }) => name === 'Components')[0].navChildren;
          return (
            <div className="page-boxes page-boxes-flex">
              {allElements.map(elem => (
                <Link
                  key={elem.path}
                  to={`/components${elem.path}`}
                  className="page-box page-box--with-icon page-box--components"
                >
                  {elem.name}
                </Link>
              ))}
              <div className="page-box page-box--empty"></div>
              <div className="page-box page-box--empty"></div>
              <div className="page-box page-box--empty"></div>
            </div>
          )
        }}
      />
    </div>
  </React.Fragment>
)

export default Components
